import type { FC } from 'react';
import {
  DesktopOutlined,
  FolderOpenOutlined,
  PieChartOutlined,
  QrcodeOutlined,
  ReconciliationOutlined,
  UserOutlined,
  WarningOutlined,
  UserAddOutlined,
  ExceptionOutlined,
  ExclamationCircleOutlined,
  VideoCameraOutlined,
  MobileOutlined,
  FileTextOutlined,
  TruckOutlined,
  TagOutlined,
  HistoryOutlined,
  SlidersOutlined,
  ShopOutlined,
  SearchOutlined,
  GlobalOutlined,
  ApiOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import React from 'react';

interface CustomIconProps {
  type: string;
}

export const CustomIcon: FC<CustomIconProps> = (props) => {
  const { type } = props;
  let com;

  if (type === 'search') {
    com = <SearchOutlined rev={undefined} />;
  } else if (type === 'globalSearch') {
    com = <GlobalOutlined rev={undefined} />;
  } else if (type === 'account') {
    com = <UserAddOutlined rev={undefined} />;
  } else if (type === 'fmcsa') {
    com = <PieChartOutlined rev={undefined} />;
  } else if (type === 'contact') {
    com = <DesktopOutlined rev={undefined} />;
  } else if (type === 'camera') {
    com = <VideoCameraOutlined rev={undefined} />;
  } else if (type === 'unpaid-companies') {
    com = <ExceptionOutlined rev={undefined} />;
  } else if (type === 'disputed-companies') {
    com = <ExclamationCircleOutlined rev={undefined} />;
  } else if (type === 'user-companies') {
    com = <ReconciliationOutlined rev={undefined} />;
  } else if (type === 'user') {
    com = <UserOutlined rev={undefined} />;
  } else if (type === 'errors') {
    com = <WarningOutlined rev={undefined} />;
  } else if (type === 'team') {
    com = <FolderOpenOutlined rev={undefined} />;
  } else if (type === 'tms') {
    com = <QrcodeOutlined rev={undefined} />;
  } else if (type === 'mobile') {
    com = <MobileOutlined rev={undefined} />;
  } else if (type === 'contracts') {
    com = <FileTextOutlined rev={undefined} />;
  } else if (type === 'sales') {
    com = <TagOutlined rev={undefined} />;
  } else if (type === 'vehicles') {
    com = <TruckOutlined rev={undefined} />;
  } else if (type === 'histories') {
    com = <HistoryOutlined rev={undefined} />;
  } else if (type === 'weigh-station') {
    com = <SlidersOutlined rev={undefined} />;
  } else if (type === 'documents') {
    com = <FileTextOutlined rev={undefined} />;
  } else if (type === 'companies') {
    com = <ShopOutlined rev={undefined} />;
  } else if (type === 'external-integrations') {
    com = <ApiOutlined />;
  } else if (type === 'system-config') {
    com = <SettingOutlined />;
  }
  return <span className="anticon">{com}</span>;
};
